import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { isPostReviewNotificationDetails as typeGuard } from "@scrile/api-provider/dist/projects/scrileConnect/PostReviewNotificationProvider";

export { default } from "./NotificationPostReview.vue";

export const selector = (item: Notification): boolean => {
  return typeGuard(item.details);
};
